export default __webpack_public_path__ + "static/media/beruehrungsloses-schalten.f4d9a049.webp";